import styles from '@/styles/goodsSmallComponent.module.scss'
import Image from 'next/image'
import Link from 'next/link'
import { formatCurrency } from '@/utils/utils'

interface GoodsSmallItem {
  name: string;
  productID: string;
  url: string;
  newThumbnail?: string;
  filename: string;
  price: number;
  normalPrice: number;
}

export default function GoodsSmallComponent(props: GoodsSmallItem) {
  return (
    <Link
      href={props.url}
      legacyBehavior
    >
      <a className={styles['goods-small-item']} rel="noopener noreferrer">
        <Image
          className={styles['goods-image']}
          src={props.newThumbnail || props.filename}
          alt={props.name}
          width={88}
          height={88}
        />
        <div className={styles['goods-info']}>
          <div className={styles['name']}>{props.name}</div>
          <div className={styles['promotion-price']}>
            {props.price ? formatCurrency(props.price) : null}
          </div>
          <div className={styles['price']}>
            {props.normalPrice ? formatCurrency(props.normalPrice) : null}
          </div>
        </div>
      </a>
    </Link>
  )
}